<template>
  <div class="container-layout" :class="containerClass">
    <slot />
  </div>
</template>

<script setup lang="ts">
interface Props {
  /** 容器最大宽度，默认为 1400px */
  maxWidth?: string
  /** 内边距，默认为 20px */
  padding?: string
  /** 外边距，默认为 0 auto */
  margin?: string
  /** 额外的CSS类名 */
  class?: string
}

const props = withDefaults(defineProps<Props>(), {
  maxWidth: '1600px',
  padding: '20px',
  margin: '0 auto',
  class: ''
})

const containerClass = computed(() => {
  return props.class ? `container-layout-custom ${props.class}` : ''
})
</script>

<script lang="ts">
import { computed } from 'vue'

export default {
  name: 'ContainerLayout'
}
</script>

<style scoped>
.container-layout {
  max-width: v-bind(maxWidth);
  margin: v-bind(margin);
  padding: v-bind(padding);
}
</style>